module.exports = __webpack_public_path__ + "static/jaana-38aae04262529a7355831f14061caa23.png";